import React, { forwardRef } from "react";
import styles from "./ButtonGreen.module.css";

const ButtonGreen = forwardRef((props, ref) => {
  return (
    <div className={styles.body}>
      <button ref={ref} className={styles.button1} onClick={props.onClick}>
        {props.icon && (<div className={styles.icon}>{props.icon}</div>)}
        <div>{props.children}</div>
      </button>
    </div>
  );
});

export default ButtonGreen;
